import t from '../../../lib/i18n';
import { CONTEXT } from 'config';
import useConfig from '../../../hooks/useConfig';

import '../../../styles/components/favourites/login.scss';
import FavouritesLoginLink from "./FavouritesLoginLink";
import FavouritesLoginButton from "./FavouritesLoginButton";

const FavouritesLogin = () => {
  const { context } = useConfig();

  const renderLoginButton = () => {
    switch (context) {
      case CONTEXT.BOOKING_ENGINE:
        return <FavouritesLoginButton />
      default:
        return <FavouritesLoginLink />
    }
  }

  return (
    <div className="otrl-jp__favourites-login">
      <div className="otrl-jp__favourites-login__message">
        {t("favourites.login.message")}
      </div>
      {renderLoginButton()}
    </div>
  );
};

export default FavouritesLogin;
